export interface PackageModalLocation {
  id: string;
  name: string;
  address: string;
  fullData: unknown;
}

function isActiveLocation(location: Record<string, unknown>): boolean {
  return location.status === true || location.status === 'active' || location.status === undefined;
}

function locationAddress(location: Record<string, unknown>): string {
  return [location.street_address, location.city, location.state, location.zip_code]
    .filter(part => typeof part === 'string' && part.trim())
    .join(', ');
}

/** Accept `{ data: [...] }` from staff or chat APIs, or a bare array. */
export function locationsFromApiResponse(response: unknown): unknown[] {
  if (Array.isArray(response)) {
    return response;
  }
  if (response && typeof response === 'object' && Array.isArray((response as { data?: unknown }).data)) {
    return (response as { data: unknown[] }).data;
  }
  return [];
}

/** Map chat/staff location rows to the package-modal dropdown. */
export function mapPackageModalLocations(response: unknown): PackageModalLocation[] {
  return locationsFromApiResponse(response)
    .filter((location): location is Record<string, unknown> => !!location && typeof location === 'object')
    .filter(isActiveLocation)
    .map(location => ({
      id: String(location.id || ''),
      name: String(location.branch || location.name || 'Unknown Location'),
      address: locationAddress(location),
      fullData: location,
    }))
    .filter(location => !!location.id);
}
